<template>
  <header class="text-center py-5" style="text-wrap: balance;">
  <h5 class="">Appstatus</h5>
  <p class="">Här rapporterar vi buggar och uppgraderingar som påverkar våra digitala tjänster.</p>
  </header>
  <div class="px-3" style="margin-top: -2.5em;">
  <div v-for="notes in notifications" :key="notes.id" class="accordion p-0 rounded mb-2 bg-white" :id="'accordion' + notes.id">

    <!--Ja lade d-block här så länge, för att skriva över display:flex; som ligger på notification-klassen, annars hamnade beskrivningen på samma rad som rubrik och accordion-toggle. 
    Ska prioritet fortfarande styra färg? -->
    <div class="accordion-item notification-item d-block border-0 p-3">

      <!-- Rubrik -->
      <div class="accordion-header">
        <button class="accordion-button p-0 fw-normal collapsed d-flex" type="button" data-bs-toggle="collapse" :data-bs-target="'#collapse' + notes.id" aria-expanded="false" :aria-controls="'collapse' + notes.id">
          <div><small class="d-block mb-1">{{ notes.date.replace('T', ' ').slice(0,16) }} <span class="badge me-1" style="color: #276f80; background-color: #d4f9fc;" v-for="tag in notes.acf.tags" :key="tag"> {{ tag }}</span><span :class="'badge bg-' + notes.acf.status"> {{ notes.acf.status == 'troubleshooting' ?  'Felsöker' : notes.acf.status == 'upgrade' ? 'Uppgradering' : notes.acf.status == 'fixed' ? 'Åtgärdat' : 'Okänd'}}</span></small>
          <strong class="title">{{ notes.title.rendered }}</strong>
        </div>
        </button>
        <!--Ha så kul-->
      </div>

      <!-- Beskrivning av problemet eller vad det nu är. -->
      <div :id="'collapse' + notes.id" class="accordion-collapse collapse" :data-bs-parent="'#accordion' + notes.id">
        <div class="accordion-body p-0 mt-3">
          <div>
          </div>
          <div v-html="notes.content.rendered"></div>
        </div>
      </div>


    </div>
  </div>
</div>
</template>

<script>

export default {
  data() {
    return {
      notifications: [],
      timeNow: Date.now() / 1000
    };
  },

  props: { site: { type: String }, updateNoteCount: {type: Function} },
  methods: {

    fetchNotifications() {
      fetch("https://apps.gavleenergi.se/powerplant-webservice/servicepoint/notifications/")
        .then((res) => res.json())
        .then((json) => {
          //Kollar site och "bäst-före-datum".
          json.map((note) => {
            if ( note.acf.type.indexOf("status") != -1 && note.acf.status_site &&
              //note.acf.site.indexOf(this.site) != -1 &&
              note.acf.status_site.indexOf(this.site) != -1 &&
              this.convertTime(note.acf.expiration_date) > this.timeNow
            ) {
              this.notifications.push(note);
        
            }
          });
          this.updateNoteCount(this.notifications.length)
        });
    },
    convertTime(uglyDate) {
      //I de fall inget bäst-före-datum är satt.
      if (uglyDate == "") {
        return this.timeNow * 2;
      }

      const [dateComponents, timeComponents] = uglyDate.split(" ");
      //console.log(dateComponents); // 👉️ "06/26/2022"
      //console.log(timeComponents); // 👉️ "04:35:12"

      const [year, month, day] = dateComponents.split("/");
      const [hours, minutes] = timeComponents.split(":");

      const date = new Date(+year, month - 1, +day, +hours, +minutes);
      //console.log(date); // 👉️ Sun Jun 26 2022 04:35:12

      const timestampInSeconds = Math.floor(date.getTime() / 1000);
      //console.log(this.timeNow)
      //console.log(timestampInSeconds); // 👉️ 1650080712

      return timestampInSeconds;
    },
  },

  mounted() {
    this.fetchNotifications();
  },
};
</script>

<style scoped></style>
